/*
 * Copyright (c) 2026 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

export type FileDataZipImportJobStatus = 'PENDING' | 'IN_PROGRESS' | 'COMPLETE' | 'FAILED';

export interface FileDataZipImportFailedFile {
    path: string;
    reason: string;
}

/**
 * Poll response of GET /esciUI/fileDataZipImport/{jobId}. totalFiles is null until the zip has been opened;
 * the two lists are null until the job is COMPLETE or FAILED.
 */
export interface FileDataZipImportStatus {
    jobId: string;
    fileName: string;
    status: FileDataZipImportJobStatus;
    message: string | null;
    totalFiles: number | null;
    succeededCount: number;
    failedCount: number;
    succeeded: string[] | null;
    failed: FileDataZipImportFailedFile[] | null;
}

export function isFileDataZipImportFinished(status: FileDataZipImportStatus | null): boolean {
    return status?.status === 'COMPLETE' || status?.status === 'FAILED';
}
